/** Create or update a KB article. */
export const kbArticleSaveSpec = {
    uri: '/kb/article/[article]',
    method: 'PUT',
    adminOnly: true,
};
